var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"CustomerEdit"}},[_c('CustomerForm',{attrs:{"user":_vm.user,"submitForm":_vm.updateRow,"hasCustomer":"true","buttonText":"Guardar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }